import { actions } from "./action-list";

export function selectDateFilter(value) {
  return {
    type: actions.SELECTED_DATE_FILTER,
    value,
  };
}
